
export function convertArrayToMap(array: Array<{ key: string; value: string }>): Map<string, string> {
    return new Map(array.map(item => [item.key, item.value]));
}

// Axios cancellation surfaces in several shapes; all mean "ignore". A cancelled request
// is an intended outcome, not a failure.
export function isCanceledError(err: any): boolean {
    return err?.code === "ERR_CANCELED" || err?.name === "CanceledError" || err?.name === "AbortError";
}

export function extractErrorMessage(err: any): string | null {
    const body = err?.response?.data;
    const message = body?.message ?? body?.error;
    if (Array.isArray(message)) {
        const joined = message.filter(Boolean).join('; ');
        return joined || null;
    }
    if (typeof message === 'string' && message.trim()) {
        return message;
    }
    return null;
}

export function move<T>(fromIndex: number, toIndex: number, array: T[]): T[] {
    const result = [...array];
    const [removed] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, removed);
    return result;
}